// extracted by mini-css-extract-plugin
module.exports = {"container":"TermsOfUse_container__GIBEP","header":"TermsOfUse_header__NAbnR","header__item":"TermsOfUse_header__item__DuhIA"};